import EventPlacements from "./EventPlacements";
export default EventPlacements;
